import { MAXIMUM_HEIGHT, MAXIMUM_WIDTH } from "common/screen";
import { html, LitElement } from "lit-element";
import { styleMap } from "lit-html/directives/style-map";
export class FinishButton extends LitElement {
    constructor() {
        super(...arguments);
        this.buttonEnable = false;
    }
    createRenderRoot() {
        return this;
    }
    render() {
        const buttonStyle = {
            top: `${MAXIMUM_HEIGHT - 400}px`,
            left: `${MAXIMUM_WIDTH / 3}px`,
            width: `${(MAXIMUM_WIDTH * 2) / 3}px`,
            height: "400px",
            position: "absolute",
            background: "none",
            border: "none",
        };
        return html `<a
      class="pointer-allow"
      style="${styleMap(buttonStyle)}"
      href="https://www.youtube.com/bigkingtravel"
      target="_blank"
      rel="noopener"
    ></a>`;
    }
}
customElements.define("jh-finish-button", FinishButton);
//# sourceMappingURL=finishButton.js.map